import React from "react";

import AccountCreationCompleted from "../components/auth/AccountCreationCompleted";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Login = () => {
  return (
    <div>
      <Header />
      <AccountCreationCompleted />
      <Footer />
    </div>
  );
};

export default Login;
